module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n        ©\n        "), _c('a', {
    attrs: {
      "href": "//www.empreinte.com/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(new Date().getFullYear()) + " Empreinte.com")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33d722cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 156
// module chunks = 1